export const DOCUMENT_TYPES = {
  PLANNED_PROCUREMENT_NOTICE: 'planned-procurement-notice',
  TENDER_NOTICE: 'tender-notice',
  AWARD_NOTICE: 'award-notice',
  CONTRACT_NOTICE: 'contract-notice',
  COMPLETION_CERTIFICATE: 'completion-certificate',
  PROCUREMENT_PLAN: 'procurement-plan',
  BIDDING_DOCUMENTS: 'bidding-documents',
  TECHNICAL_SPECIFICATIONS: 'technical-specifications',
  EVALUATION_CRITERIA: 'evaluation-criteria',
  EVALUATION_REPORT: 'evaluation-report',
  CONTRACT_DRAFT: 'contract-draft',
  SIGNED_CONTRACT: 'signed-contract',
  CONTRACT_ARRANGEMENTS: 'contract-arrangements',
  CONTRACT_SCHEDULE: 'contract-schedule',
  PHYSICAL_PROGRESS_REPORT: 'physical-progress-report',
  FINANCIAL_PROGRESS_REPORT: 'financial-progress-report',
  FINAL_AUDIT: 'final-audit',
  PUBLIC_HEARING_NOTICE: 'public-hearing-notice',
  MARKET_STUDIES: 'market-studies',
  ELIGIBILITY_CRITERIA: 'eligibility-criteria',
  CLARIFICATIONS: 'clarifications',
  SHORTLISTED_FIRMS: 'shortlisted-firms',
  ENVIRONMENTAL_IMPACT: 'environmental-impact',
  ASSET_AND_LIABILITY_ASSESSMENT: 'asset-and-liability-assessment',
  RISK_PROVISIONS: 'risk-provisions',
  WINNING_BID: 'winning-bid',
  COMPLAINTS: 'complaints',
  CONTRACT_ANNEXE: 'contract-annexe',
  CONTRACT_GUARANTEES: 'contract-guarantees',
  SUB_CONTRACT: 'sub-contract',
  NEEDS_ASSESSMENT: 'needs-assessment',
  FEASIBILITY_STUDY: 'feasibility-study',
  PROJECT_PLAN: 'project-plan',
  BILL_OF_QUANTITY: 'bill-of-quantity',
  BIDDERS: 'bidders',
  CONFLICT_OF_INTEREST: 'conflict-of-interest',
  DEBARMENTS: 'debarments',
  ILLUSTRATION: 'illustration',
  SUBMISSION_DOCUMENTS: 'submission-documents',
  CONTRACT_SUMMARY: 'contract-summary',
  CANCELLATION_DETAILS: 'cancellation-details',
};

export const DOCUMENT_TYPES_VALUES = Object.values(DOCUMENT_TYPES);
